export default __webpack_public_path__ + "static/media/desktop_banner_home.c73c019e.jpg";